import { DetailTitleCells } from 'app/models/report-details.models';
import { OperationsColumn } from 'app/models/operations.models';

export const cells = [
  { name: OperationsColumn.OfficerName, title: DetailTitleCells.OFFICER_NAME },
  { name: OperationsColumn.Badge, title: DetailTitleCells.BADGE },
  { name: OperationsColumn.Rank, title: DetailTitleCells.RANK },
  {
    name: OperationsColumn.TotalCitations,
    title: DetailTitleCells.TOTAL_CITATIONS_COUNT,
  },
  {
    name: OperationsColumn.TotalWarnings,
    title: DetailTitleCells.TOTAL_WARNINGS_COUNT,
  },
  { name: OperationsColumn.LastLoginDT, title: DetailTitleCells.LAST_LOGIN_DT },
  {
    name: OperationsColumn.LastCitationDT,
    title: DetailTitleCells.LAST_CITATION_DT,
  },
  {
    name: OperationsColumn.LastWarningDT,
    title: DetailTitleCells.LAST_WARNING_DT,
  },
  {
    name: OperationsColumn.Last7DaysCitations,
    title: DetailTitleCells.LAST_7_DAYS_CITATIONS,
  },
  {
    name: OperationsColumn.Last30DaysCitations,
    title: DetailTitleCells.LAST_30_DAYS_CITATIONS,
  },
  {
    name: OperationsColumn.Last7DaysWarnings,
    title: DetailTitleCells.LAST_7_DAYS_WARNINGS,
  },
  {
    name: OperationsColumn.Last30DaysWarnings,
    title: DetailTitleCells.LAST_30_DAYS_WARNINGS,
  },
];
export const dateCells = [
  OperationsColumn.LastLoginDT,
  OperationsColumn.LastCitationDT,
  OperationsColumn.LastWarningDT,
];
